module.exports = __webpack_public_path__ + "static/media/facebook.bc53f7eb.png";